
export default {
  baseApiUrl: null
}